import { createContext, use } from "react";
import { defined } from "@entrilia/shared/utilities/typeHelper.ts";
import type { ReportGroup, ReportTemplate, Status } from "../../../../../api/types/svTypes.ts";

export interface ReportTemplatesContextType {
  reportTemplates: ReportTemplate[];
  groups?: ReportGroup[] | undefined;
  groupsUi?: { loaded: boolean; error?: string };
  ui: {
    loaded: boolean;
    error?: string;
  };
  actions: {
    reloadReportTemplates: () => Promise<void>;
    switchStatus: (template: ReportTemplate, status: Status) => Promise<boolean>;
  };
}

export const ReportTemplatesContext = createContext<ReportTemplatesContextType | undefined>(undefined);

export const useReportTemplatesContext = () => {
  const context = use(ReportTemplatesContext);
  return defined(context);
};
